module.exports = __webpack_public_path__ + "h5/img/404.694f21a5.png";